const MotionGlobalConfig = {};
export {
  MotionGlobalConfig
};
